import { Grid } from '@mui/material'
import AuroraAssetGroupTemperatureControls from './AuroraAssetGroupTemperatureControls'
import AuroraAssetGroupHeatPumpControls from './AuroraAssetGroupHeatPumpControls'
import AuroraAssetGroupCirculationPumpControls from './AuroraAssetGroupCirculationPumpControls'
import AuroraAssetGroupBoilerControls from './AuroraAssetGroupBoilerControls'
import { AuroraAssetGroup } from '../types'
import { useAuroraStack } from '../hooks/aurora'

interface AuroraAssetGroupControlsProps {
  auroraAssetGroup: AuroraAssetGroup
}

export default function AuroraAssetGroupControls({
  auroraAssetGroup
}: AuroraAssetGroupControlsProps) {
  const { hasAwhpUnits, hasBackupUnits } = useAuroraStack(auroraAssetGroup)

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <AuroraAssetGroupTemperatureControls auroraAssetGroup={auroraAssetGroup} />
      </Grid>

      <Grid item xs={12} lg={6}>
        {hasAwhpUnits && <AuroraAssetGroupHeatPumpControls auroraAssetGroup={auroraAssetGroup} />}
      </Grid>

      <Grid item xs={12} lg={6}>
        <AuroraAssetGroupCirculationPumpControls auroraAssetGroup={auroraAssetGroup} />
      </Grid>

      {/*hasBackupUnits && (
        <Grid item xs={12} lg={6}>
          <AuroraAssetGroupBoilerControls auroraAssetGroup={auroraAssetGroup} />
        </Grid>
      )*/}
    </Grid>
  )
}
